/**
 * 任务类型
 */
export enum JobType {
  /** 录屏工具的视频录制 */
  VrecRecording = 'vrec.recording',
  /** 视频编辑器导出 */
  VeRender = 've.render',
  /** 快速替换导出 */
  VeSimple = 've.simple',
  /** AI视频导出任务 */
  AigcTask = 'aigc.task',
  /** 通用模板的多组合打包下载 */
  GmDown = 'gm.down',
  /** 通用模板的多组合打包推送 */
  GmPush = 'gm.push',
  /** 定制模板的多组合打包下载 */
  DmDown = 'dm.down',
  /** 定制模板的多组合打包推送 */
  DmPush = 'dm.push',
  /** Ai消除 */
  VeElimination = 've.elimination',
  /** 工单 */
  DemandOrder = 'demand.order',
  /** 视频ocr */
  VeOcr = 've.ocr',
  /** ai banner */
  AiBanner = 'ai.banner',
  /** 数字人视频 */
  AvatarVideo = 'avatar_to_video',
}

export enum JobStatus {
  Pending = 'pending',
  /** 任务执行中 */
  Running = 'running',
  /** 任务处理成功 / 工单已完成 */
  Success = 'success',
  /** 任务处理失败 / 工单被拒绝 */
  Failed = 'failed',
  /** 部分成功 */
  PartSuccess = 'part_success',
  /** 终止 */
  Stopped = 'stopped',
}

/** 任务是否未读 */
export enum Unread {
  /** 未读 */
  Yes = 1,
  /** 以读 */
  No = 0,
}
